import { render, staticRenderFns } from "./cl-exercise-detail-left.vue?vue&type=template&id=15e9ad80&scoped=true"
import script from "./cl-exercise-detail-left.vue?vue&type=script&lang=js"
export * from "./cl-exercise-detail-left.vue?vue&type=script&lang=js"
import style0 from "./cl-exercise-detail-left.vue?vue&type=style&index=0&id=15e9ad80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e9ad80",
  null
  
)

export default component.exports